<template>
	<v-container fluid pt-0>
		<v-card class="mt-4">
			<v-card-text>
				<v-row>
					<v-col></v-col>
					<v-col class="d-flex justify-center pb-0 pt-0">
						<v-card-title class="text-center pa-2 pb-0 pt-0"> {{ $t('titles.gantt') }}</v-card-title>
					</v-col>
					<v-col class="d-flex justify-end pa-0 pr-2">
						<v-btn color="primary" @click="getMonthlyPlan">
							<v-icon small>fa-file-excel</v-icon>&nbsp;&nbsp;{{ $t('buttons.getMonthlyPlan') }}
						</v-btn>
					</v-col>
				</v-row>
				<v-col cols="12">
					<v-row>
						<v-col cols="12">
							<v-btn class="mr-2" color="primary" @click="adjustMonth(-1)">
								{{ $t('buttons.previousMonth') }}
							</v-btn>
							<v-btn class="mr-2" color="primary" @click="adjustMonth(+1)">
								{{ $t('buttons.nextMonth') }}
							</v-btn>
							<span>
								{{ monthNameCroatian + ' (' + formattedDateRange + ')' }}
							</span>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<Gantogram
								:date-from="gantogramData.dateFrom"
								:date-to="gantogramData.dateTo"
								:events="gantogramData.events"
								:categories="gantogramData.categories"
								@clicked="eventClicked"
							></Gantogram>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import Gantogram from './Gantogram.vue';

export default {
	name: 'Gantt',
	components: { Gantogram },
	data() {
		return {
			gantogramData: {
				dateFrom: '',
				dateTo: '',
				events: [],
				categories: [
					{
						label: 'Rijeka',
						minimumSize: 2,
					},
					{
						label: 'Split',
						minimumSize: 2,
					},
					{
						label: 'Šibenik',
						minimumSize: 2,
					},
					{
						label: 'Zadar',
						minimumSize: 2,
					},
					{
						label: 'Zagreb',
						minimumSize: 2,
					},
				],
			},
			monthNameCroatian: '',
		};
	},
	computed: {
		formattedDateRange() {
			let moment = require('moment');
			let dateFrom = moment(this.gantogramData.dateFrom, 'YYYY-MM-DD');
			let dateTo = moment(this.gantogramData.dateTo, 'YYYY-MM-DD');
			return dateFrom.format('D.M.YYYY.') + ' - ' + dateTo.format('D.M.YYYY.');
		},
	},
	methods: {
		eventClicked(event) {
			this.$router.push('/planned-courses/' + event['planned_course_id']);
		},
		calculateCurrentMonthDates() {
			const today = new Date();
			const year = today.getFullYear();
			const month = today.getMonth() + 1;

			const firstDate = new Date(year, month - 1, 1);
			this.gantogramData.dateFrom = this.formatDate(firstDate);

			const lastDate = new Date(year, month, 0);
			this.gantogramData.dateTo = this.formatDate(lastDate);
		},
		formatDate(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		getMonthlyPlan() {
			let vm = this;
			let payload = {
				data: {
					start_date: this.gantogramData.dateFrom,
					end_date: this.gantogramData.dateTo,
				},
			};
			this.$APICall(
				'get',
				'planned-courses-monthly-plan-export',
				payload,
				(data, succes) => {
					if (succes) {
						window.open(data.link);
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		getEvents() {
			let vm = this;
			let payload = {
				data: {
					start_date: this.gantogramData.dateFrom,
					end_date: this.gantogramData.dateTo,
				},
			};
			this.$APICall(
				'get',
				'planned-courses-monthly-events',
				payload,
				(data, succes) => {
					if (succes) {
						vm.gantogramData.events = [];
						vm.gantogramData.events = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		adjustMonth(delta) {
			let moment = require('moment');
			let startDate = moment(this.gantogramData.dateFrom, 'YYYY-MM-DD');
			startDate = startDate.add(delta, 'months');
			let endDate = moment(startDate).endOf('month');
			this.gantogramData.dateFrom = startDate.format('YYYY-MM-DD');
			this.gantogramData.dateTo = endDate.format('YYYY-MM-DD');
			this.getEvents();
		},
	},
	mounted() {
		this.calculateCurrentMonthDates();
		this.getEvents();

		let vm = this;

		this.$myStore.commit('setBreadcrumbs', [
			{
				text: vm.$t('modules.gantt'),
				href: '/#/gantt',
				disabled: true,
			},
		]);
	},
};
</script>

<style scoped></style>
